import script from "./HomeLaborCostModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeLaborCostModal.vue?vue&type=script&setup=true&lang=ts"

import "./HomeLaborCostModal.vue?vue&type=style&index=0&id=067e0f68&lang=scss"

const __exports__ = script;

export default __exports__